import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { ReactElement } from 'react'
import type { TestManagementToolInputs } from '@eggplant/types'

interface Props {
  id: string
  children?: (response: TestManagementToolInputs) => ReactElement
  onSuccess?: (notificationSettings: TestManagementToolInputs) => void
  params?: TestManagementToolInputs
}

const UpdateTestManagementIntegrationRequest = ({
  id,
  children,
  onSuccess,
  params
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/integrations/${id}`

  const { requestParams } = useGetParamsWithSpaceId<TestManagementToolInputs | undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default UpdateTestManagementIntegrationRequest
